import analyticsView from '../../containers/analytics/analyticsView';
import Engagement from '../../containers/analytics/Engagement';
import DataSources from '../../containers/analytics/DataSources';
import DataSourcesByArea from '../../containers/analytics/DataSourcesByArea';
import Overview from '../../containers/analytics/Overview';
import OverviewArea from '../../containers/analytics/OverviewArea';
import Overlap from '../../containers/analytics/Overlap';
import SecurityOverview from '../../containers/analytics/SecurityOverview';
import SecurityCriticalAcceptableDetail from '../../components/analytics/SecurityCriticalAcceptableDetail';
import SecurityCriticalRudimentaryDetail from '../../components/analytics/SecurityCriticalRudimentaryDetail';
import SecurityCriticalInadequateDetail from '../../components/analytics/SecurityCriticalInadequateDetail';
import SecurityNonCriticalAcceptableDetail from '../../components/analytics/SecurityNonCriticalAcceptableDetail';
import SecurityNonCriticalRudimentaryDetail from '../../components/analytics/SecurityNonCriticalRudimentaryDetail';
import SecurityNonCriticalInadequateDetail from '../../components/analytics/SecurityNonCriticalInadequateDetail';
import SecurityDashboardsOverview from '../../containers/analytics/SecurityDashboardsOverview';
import SecurityDashboardsDetail from '../../containers/analytics/SecurityDashboardsDetail';
import SecurityDashboardsOtherDetail from '../../containers/analytics/SecurityDashboardsOtherDetail';

export default [
  Engagement,
  DataSources,
  DataSourcesByArea,
  Overview,
  OverviewArea,
  SecurityOverview,
  SecurityCriticalAcceptableDetail,
  SecurityCriticalRudimentaryDetail,
  SecurityCriticalInadequateDetail,
  SecurityNonCriticalAcceptableDetail,
  SecurityNonCriticalRudimentaryDetail,
  SecurityNonCriticalInadequateDetail,
  SecurityDashboardsOverview,
  SecurityDashboardsDetail,
  SecurityDashboardsOtherDetail,
  Overlap
].map(component => analyticsView(component));



// WEBPACK FOOTER //
// ./src/routing/analytics/components.js